var URL_CHECKS = ['https://api.teyuto.tv', 'http://localhost:8082', 'https://sendbox.teyuto.tv'];
var URL_API = 'https://api.teyuto.tv/v1';
var URL_API1 = 'https://api.teyuto.tv/v1_1';
var URL_API2 = 'https://api.teyuto.tv/v2';
var ONLINE_STATUS = true;
var pusher;
//storage info
var GB_FREE_SPACE = 0;
var GB_DEVICE_SPACE = 0;
var GB_APP_SPACE = 0;
//debug
// URL_API = 'https://api-staging.teyuto.tv/v1';
// URL_API1 = 'https://api-staging.teyuto.tv/v1_1';
// URL_API2 = 'https://api-staging.teyuto.tv/v2';

var currentPageState = [];
var currentPageDepth = {};
var listDownloadedVideosIds = [];
var cicleProgressDownloads = [];

// Delega a Nav (js/nav.js): stack e history restano sempre sincronizzati.
// Mantenuta per compatibilità con i call site esistenti.
function addPageToState(page){
    Nav.push(page);
}

var URL_PLAYER='';
var IS_MOBILE_APP = true;

//compatibilità e variabili globali
var userDeviceLanguage='';
var CHANNEL_ID;
var APPLE_STORE_ID;
var PLAY_STORE_ID;
var APP_VERSION;
var currentLang;
var companySettings;
var companyAuth0Enabled = false;
var companyActiveLanding = 'standard';
var LANGUAGE_LINES;
var companyBackgroundColor = '';
var companyPrimaryColor = '';
var companyTextColor = '#ffffff';
var companyId = '';
var companyName = '';
var companyLogo = '';
var companyDomain = '';
var companyIsFullScreenVideo = false;
var companyVideoChat =  false;
var companyVideoComment =  false;
var companyRelatedVideo =  false;
var companyShowVideoView =  false;
var companyShowVideoViewThumb =  false;
var companyShowLikeVideo =  false;
var companyThumbShowTitle = false;
var companySupportEmail = '';
var companyLanguages;
var userDevice;
var userData = null;
var companyCustomHomePages = [];
var companyNumberCategories = 0;
var lastVideoSource = null;
var lastVideoIdOpened = null;
var companyThemeDark = false;

var currentCustomPageActive = 'user';
var currentVIdeoSubtitle = null;

//utiliy
var currentCollectionTitle = '';

var currentAjaxRequest = null;
//

var hostname = window.location.hostname;
var proxyUrl = '';

var SUB_DOMAIN = /:\/\/([^\/]+)/.exec(window.location.href)[1];


function translate(string) {
	let stringTranslated = LANGUAGE_LINES && LANGUAGE_LINES[string];
	if (typeof stringTranslated === 'string' && stringTranslated.trim() !== '') {
		return stringTranslated;
	}
	console.warn('Translation unavailable for:', string);
	return string
		.replace(/_/g, ' ')
		.toLowerCase()
		.replace(/^./, function(match) { return match.toUpperCase(); });
}

var userToken = null;

function normalizeChannelLanguage(language) {
    var parts = String(language).replace(/_/g, '-').split('-');
    var base = parts[0].toLowerCase();
    if (base === 'pt' && parts[1] && /^(br|pt)$/i.test(parts[1])) {
        return base + '-' + parts[1].toUpperCase();
    }
    return base;
}

XMLHttpRequest.prototype.open = (function (open) {
    return function (method, url, async) {
        // console.log('the outgoing url is',url);
        open.apply(this, arguments);
        if (typeof userDevice === "undefined") {
            userDevice = null;
        }
        if (URL_CHECKS.some(parte => url.includes(parte))) {
            // console.log("contenuto");
            var languageSent = userDeviceLanguage;
            if(currentLang){
                languageSent = currentLang;
            }
            if(languageSent){
                languageSent = normalizeChannelLanguage(languageSent);
            }

            //debug
            // languageSent='en';
            // alert(languageSent);
            // console.log(CHANNEL_ID + " for "+ url);
            this.setRequestHeader('Authorization', userToken);
            this.setRequestHeader('channel', CHANNEL_ID);
            this.setRequestHeader('x-teyuto-device', userDevice);
            // il backend distingue app/web da questo header (es. homepage app
            // vs landing web): sul web servito dalla shell PHP deve essere false
            this.setRequestHeader('x-teyuto-app', window.TY_WEB ? "false" : "true");
            this.setRequestHeader('x-teyuto-language', languageSent);

            
        }
    };
})(XMLHttpRequest.prototype.open);

setInterval(function () {
	var request = new XMLHttpRequest();
	request.open('GET', URL_API + '/user/?f=uact', true);

	request.onload = function() {
	if (request.status >= 200 && request.status < 400) {
		var data = JSON.parse(request.responseText);
		if (data && data.status === 'block') {
			logoutFromAccount(); //!todo
		}else if(data.email_verified==false){
            showEmailToVerify(); //!todo
        }
	} 
	};
	request.onerror = function() {
	// console.error("Request failed");
	};

	request.send();
}, 30000);


var pathHomepage = '/';

function showEmailToVerify(){
   window.plugins.toast.showShortBottom('You must verify your email');
}

function getCurrentStringML(text, lang) {
	if (!text) {
		return '';
	}
	let stringBetweenMLTag = getTextBetweenStrings(text, "[" + lang + "]", "[/" + lang + "]");

	if (!stringBetweenMLTag) {
		for (var i = 0; i < companyLanguages.length; i++) {
			// console.log(languages);
			stringBetweenMLTag = getTextBetweenStrings(text, "[" + companyLanguages[i] + "]", "[/" + companyLanguages[i] + "]");
			if (!!stringBetweenMLTag) {
				return stringBetweenMLTag;
			}
		}
		if (!stringBetweenMLTag) {
			return text;
		} else {
			return stringBetweenMLTag;
		}
	} else {
		return stringBetweenMLTag;
	}
}


function getTextBetweenStrings(inputString, prefix, suffix) {
	if (!!inputString) {
		var i = inputString.indexOf(prefix);
		let checkIfExist = false;
		if (i >= 0) {
			inputString = inputString.substring(i + prefix.length);
			checkIfExist = true;
		}
		if (suffix) {
			i = inputString.indexOf(suffix);
			if (i >= 0) {
				inputString = inputString.substring(0, i);
				checkIfExist = true;
			}
		}
		if (checkIfExist == true) {
			return inputString;
		} else {
			return;
		}
	} else {
		return;
	}
};

function getUrlParameter(name, url = window.location.href) {
	name = name.replace(/[\[\]]/g, "\\$&");
	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return "";
	return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function addQueryParam(key, value) {
	let currentUrl = new URL(window.location.href);
	currentUrl.searchParams.set(key, value);
	window.history.replaceState({}, document.title, currentUrl.toString());
}

let oldElSpinnerSave = '';
function saveSpinnerState(selector, state = false) {
    const el = document.querySelector(selector);
    if (!el) { return; }
    if (state === false) {
        oldElSpinnerSave = el.innerHTML;
        el.innerHTML = '<i class="ri-loader-4-line fx-spin"></i>';
        el.disabled = true;
    } else {
        el.innerHTML = oldElSpinnerSave;
        el.disabled = false;
        oldElSpinnerSave = '';
    }
}

function escapeStringQuotes(str) {
    return str.replace(/'/g, "\\'");
}

function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
